import { Mapper } from 'src/base/mapper'
import { PlanDataTableTypeEntity } from 'src/data/entities/plan.entity'
import { PlanDataTableTypeModel } from 'src/domain/models/plan.model'

export class PlanDataTableMapper extends Mapper<PlanDataTableTypeEntity, PlanDataTableTypeModel> {
	mapFrom(param: PlanDataTableTypeEntity): PlanDataTableTypeModel {
		return {
			planId: param.planId,
			planName: param.planName,
			planCode: param.planCode,
			planDescription: param.planDescription,
			url: param.url,
			isActive: param.isActive,
			pricingScheme: param.pricingScheme,
			freeTrial: param.freeTrial,
			startQty: param.startQty,
			endQty: param.endQty,
			price: param.price,
			planType: param.planType,
			billEvery: param.billEvery,
			billingInterval: param.billingInterval,
			addonType: param.addonType,
			logoUrl: param.logoUrl,
			planGroupId: param.planGroupId,
		}
	}

	mapTo(param: PlanDataTableTypeModel): PlanDataTableTypeEntity {
		return {
			planId: param.planId,
			planName: param.planName,
			planCode: param.planCode,
			planDescription: param.planDescription,
			url: param.url,
			isActive: param.isActive,
			pricingScheme: param.pricingScheme,
			freeTrial: param.freeTrial,
			startQty: param.startQty,
			endQty: param.endQty,
			productId: null,
			productName: null,
			planType: param.planType,
			price: param.price,
			unitId: null,
			updatedByUserId: null,
			dateUpdated: null,
			createdByUserId: null,
			dateCreated: null,
			billEvery: param.billEvery,
			billingCycle: null,
			billingInterval: param.billingInterval,
			binaryFile: null,
			addonType: param.addonType,
			taxId: null,
			associatePlans: null,
			isDelete: null,
			extension: null,
		}
	}
}
